/**
 * Kuruş hassasiyetli para aritmetiği (BigInt): istemci tarafı özetler (ör. dönem toplamı) yuvarlama hatasız
 * hesaplanır; tutarlar decimal string olarak taşınır.
 */
export function cents(amount: string): bigint {
  const neg = amount.trim().startsWith('-')
  const [int = '0', frac = ''] = amount.trim().replace('-', '').split('.')
  const v = BigInt(int || '0') * 100n + BigInt((frac + '00').slice(0, 2))
  return neg ? -v : v
}

export const toMoney = (c: bigint) => {
  const neg = c < 0n
  const a = neg ? -c : c
  return `${neg ? '-' : ''}${a / 100n}.${(a % 100n).toString().padStart(2, '0')}`
}

/** Yüzde uygulaması; yarım kuruş yukarı yuvarlanır. */
export const pctOf = (c: bigint, rate: number) => (c * BigInt(Math.round(rate * 100)) + 5000n) / 10000n

export const sum = (list: bigint[]) => list.reduce((a, b) => a + b, 0n)

/** Önceki döneme göre % değişim (bir ondalık); önceki 0 ise null. */
export const changePct = (cur: bigint, prev: bigint) => (prev === 0n ? null : Number(((cur - prev) * 1000n) / (prev < 0n ? -prev : prev)) / 10)

/** a'nın b içindeki yüzdesi (tam sayı). */
export const ratioPct = (a: bigint, b: bigint) => (b === 0n ? 0 : Number((a * 100n) / b))
